import { motion } from "framer-motion";
import { MapPin, Award, Zap } from "lucide-react";
import { MEDIA } from "@/data/content";

const POINTS = [
  { icon: MapPin, title: "Local roots", text: "We know the Sacramento market, its neighborhoods, and its customers." },
  { icon: Award, title: "Official partner", text: "Your certified Emergent Technologies partner for the 916 and beyond." },
  { icon: Zap, title: "Fast & accountable", text: "Real timelines, transparent reporting, and a team that actually answers." },
];

export const WhySacramento = () => {
  return (
    <section data-testid="why-section" className="relative py-24 sm:py-32 border-t border-line overflow-hidden grain">
      <div className="absolute inset-0 z-0">
        <img src={MEDIA.sacramento} alt="Sacramento skyline" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-ink/85" />
      </div>

      <div className="container-x relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <span className="mono-label text-accent">[ Why us ]</span>
            <h2 className="font-head font-black tracking-tighter text-4xl sm:text-5xl lg:text-6xl mt-4 text-balance">
              Sacramento born.<br />Results obsessed.
            </h2>
            <p className="text-text-2 text-lg leading-relaxed mt-6 max-w-lg">
              We're not a faceless agency three time zones away. We're your neighbors — building
              the digital presence that helps local businesses outpace the competition.
            </p>
          </motion.div>

          <div className="space-y-px bg-line border border-line">
            {POINTS.map((p, i) => (
              <motion.div
                key={p.title}
                initial={{ opacity: 0, x: 24 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className="bg-surface/80 backdrop-blur-sm p-7 flex gap-5 items-start"
              >
                <div className="w-12 h-12 shrink-0 flex items-center justify-center border border-accent text-accent">
                  <p.icon className="w-5 h-5" />
                </div>
                <div>
                  <h3 className="font-head font-bold text-xl">{p.title}</h3>
                  <p className="text-text-2 text-sm leading-relaxed mt-1">{p.text}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
